import PropTypes from "prop-types";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Carousel } from "antd";
import React from "react";
import "./ReviewSlider.css";

/**
 * A component that renders a slider containing the reviews. It uses antd Carousel to show the slider.
 *
 * @param {Object} props
 * @param {{customer_comment: string, customer_name: string}[]} props.reviewsList - A list of the reviews to be rendered.
 * @returns {JSX.Element}
 */
export default function ReviewsSlider({ reviewsList }) {
  const settings = {
    dots: true,
    infinite: true,
    draggable: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        },
      },
    ],
  };

  return (
    <div className="h-[425px] bg-background_white md:bg-[#cacaca6d]">
      <Carousel className="reviews-first-slider" {...settings}>
        {reviewsList?.map((review, id) => (
          <div
            key={id}
            className="px-6 md:px-10 lg:px-16 xl:px-56 py-3 pb-6 md:py-6 lg:py-18 xl:py-18 flex flex-col justify-start items-center"
          >
            <div className="my-12 flex flex-row justify-center items-center">
              <Icon icon="tabler:star-filled" className="text-lg mx-1" />
              <Icon icon="tabler:star-filled" className="text-lg mx-1" />
              <Icon icon="tabler:star-filled" className="text-lg mx-1" />
              <Icon icon="tabler:star-filled" className="text-lg mx-1" />
              <Icon icon="tabler:star-filled" className="text-lg mx-1" />
            </div>
            <p className="my-3 font-bold text-base md:text-2xl text-text_black text-center">
              {review.customer_comment}
            </p>
            <p className="font-bold mx-2 text-center">
              {review.customer_name}
            </p>
          </div>
        ))}
      </Carousel>
    </div>
  );
}

// ✅ Add prop validation
ReviewsSlider.propTypes = {
  reviewsList: PropTypes.arrayOf(
    PropTypes.shape({
      customer_comment: PropTypes.string.isRequired,
      customer_name: PropTypes.string.isRequired,
    })
  ).isRequired,
};
